import { Navigate, type RouteObject } from "react-router-dom";
import { useLocale } from "@admin/app/locale";
import { useSessionQuery } from "@/shared/services/useSessionQuery";
import { ADMIN_ROLES } from "@/lib/auth/admin-roles";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { LoadingState } from "@/shared/rd";
import { IntegrationSimulatorPage } from "./pages/IntegrationSimulatorPage";
function IntegrationSimulatorRoute() {
  const locale = useLocale();
  const t = useTranslations();
  const { data, isLoading } = useSessionQuery();
  if (isLoading)
    return <LoadingState title={t(keys.shell.loadingTitle, { page: t(keys.integrationSimulator.nav).toLocaleLowerCase(locale) })} sub={t(keys.shell.loadingSub)} rows={0} />;
  if (!data?.admin?.roles?.includes(ADMIN_ROLES.SUPER_ADMIN))
    return <Navigate to={`/${locale}/admin`} replace />;
  return <IntegrationSimulatorPage />;
}
export const integrationSimulatorRoutes: RouteObject[] = [
  { path: "integration-simulator", element: <IntegrationSimulatorRoute /> },
];
